export enum UserRole {
  AGENCY_ADMIN = 'agency_admin',
  RENTER = 'renter',
}
